import { NgModule } from '@angular/core';
import { HasAnyAuthorityDirective } from './auth/has-any-authority.directive';

@NgModule({
  imports: [HasAnyAuthorityDirective],
  exports: [HasAnyAuthorityDirective]
})
export class SharedStandaloneModule {}
